export const educationExperiences = [
  {
    "period": "2025.09 ~ 2026.04",
    "title": "풀스택 웹서비스 개발 교육",
    "audience": "취업 준비생"
  },
  {
    "period": "2024.07 ~ 2025.09",
    "title": "생성형 AI 기반 웹서비스 개발 교육",
    "audience": "취업 준비생"
  },
  {
    "period": "2024.01 ~ 2024.04",
    "title": "AWS 클라우드 교육",
    "audience": "취업 준비생"
  },
  {
    "period": "2023.11 ~ 2024.07",
    "title": "Red Hat 기반 클라우드 교육",
    "audience": "취업 준비생"
  },
  {
    "period": "2021.12 ~ 2022.01",
    "title": "지능형 웹서비스 풀스택 개발 교육",
    "audience": "취업 준비생"
  },
  {
    "period": "2021.03 ~ 2023.10",
    "title": "데이터 기반 AI 시스템 엔지니어 양성 교육",
    "audience": "취업 준비생"
  },
  {
    "period": "2017.11 ~ 2018.01",
    "title": "GPU·Docker 플랫폼 구축 및 TensorFlow 인공지능 실무 교육",
    "audience": "현업 실무자"
  }
];
